export default __webpack_public_path__ + "static/media/secret_app.33ed0d5f.png";